module.exports = __webpack_public_path__ + "static/media/4.ab0aa8d9.jpg";